import PropTypes from 'prop-types';
import { Box, Typography, Switch } from '@mui/material';
import ListItemDot from 'features/IRWorkstation/components/Common/ListItemDot';
import { formatDate } from 'utils/utils';

const severityColorMap = {
	critical: 'signal.red',
	warning: 'signal.amber',
	info: 'signal.blue',
};

const AlertSubscriptionItem = ({
	alert,
	handleUnsubscribe,
	handleSubscribe,
}) => {
	const alertColor = severityColorMap[alert.severity.toLowerCase()];

	return (
		<Box
			// onClick={() => ()} // Implemented in future ticket
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				gap: '12px',
				padding: '10px 15px',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
				cursor: 'pointer',
				transition: 'background-color 0.2s',
				backgroundColor: 'background.paper',
				'&:hover': {
					backgroundColor: 'background.subtle',
				},
			}}
		>
			<ListItemDot color={alertColor} />

			{/* Main Content */}
			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Box sx={{ flex: 1 }}>
					<Typography
						sx={{
							fontSize: '13px',
							fontWeight: 600,
							color: 'text.primary',
							mb: 0.5,
						}}
					>
						{alert.title || '(No Subject)'}
					</Typography>
					<Typography
						sx={{
							fontSize: '12px',
							mb: 2,
						}}
					>
						{alert.message}
					</Typography>
					<Typography
						sx={{
							fontSize: '10px',
							color: 'text.secondary',
						}}
					>
						Created: {formatDate(alert.created_at)}
						{/* Only render for subscribed alerts */}
						{alert.subscribed_at &&
							` • Subscribed: ${formatDate(alert.subscribed_at)}`}
					</Typography>
				</Box>
			</Box>
			<Switch
				checked={alert.subscribed}
				onChange={() =>
					alert.subscribed ? handleUnsubscribe(alert) : handleSubscribe(alert)
				}
				size='small'
				sx={{ ml: 2 }}
			/>
		</Box>
	);
};

AlertSubscriptionItem.propTypes = {
	alert: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		message: PropTypes.string,
		severity: PropTypes.string,
		created_at: PropTypes.string.isRequired,
		subscribed_at: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.oneOf([null]),
		]),
		subscribed: PropTypes.bool,
	}),
	handleSubscribe: PropTypes.func.isRequired,
	handleUnsubscribe: PropTypes.func.isRequired,
};

export default AlertSubscriptionItem;
